import React, {
  useEffect,
  //  useState, useRef, useCallback, useMemo 
} from "react";
import Sliderimages from "../components/Sliderimages";
import OfferedCoursesSection from "../components/OfferedCoursesSection";
// import CollegeAtGlaneSection from "../components/CollegeAtGlanceSection";
import Footer from "../components/Footer";
// import EventsPageForHome from "./EventsPageForHome";
// import axios from "axios";
// import UserRecruiters from "./UserRecruiters";
// import HomePageTestimonial from "./HomePageTestimonial";
// import UserEnquiryModel from "../components/UserEnquiryModel";
import { useDispatch, useSelector } from "react-redux";
import LogoLoader from "../Pages/LogoLoader.jsx";
import { hideLoader, showLoader } from "../Slices/LoaderSlice.jsx";
import { useLocation } from "react-router-dom";
import Aboutus from "./Aboutus.jsx";

function Home() {
  // const [showInquiryForm, setShowInquiryForm] = useState(false);
  // const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // const [bannerReady, setBannerReady] = useState(false);
  const { pathname } = useLocation();
  // const [noimages, setNoimages] = useState(false);
  // const secondsElapsedRef = useRef(0);
  // const countdownIntervalRef = useRef(null);
  const dispatch = useDispatch();
  const { loading: collegesLoading } = useSelector((state) => state.colleges);
  // const { allEvents, loading: eventsLoading } = useSelector((state) => state.events);
  const isLoading = collegesLoading;
  // const [a, setA] = useState(false);
  // const startCountdown = useCallback(() => {
  //   countdownIntervalRef.current = setInterval(() => {
  //     secondsElapsedRef.current += 1;
  //     if (secondsElapsedRef.current === 10) {
  //       setShowInquiryForm(true);
  //       clearInterval(countdownIntervalRef.current);
  //     }
  //   }, 1000);
  // }, []);

  // const handleClose = () => {
  //   setShowInquiryForm(false);
  //   secondsElapsedRef.current = 0;
  //   startCountdown();
  // };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  // useEffect(() => {
  //   startCountdown();
  //   const handleResize = () => setIsMobile(window.innerWidth < 768);
  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     clearInterval(countdownIntervalRef.current);
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [startCountdown]);

  useEffect(() => {
    const runLoader = async () => {
      dispatch(showLoader());
      await new Promise((resolve) => setTimeout(resolve, 500));
      dispatch(hideLoader());
    };
    runLoader();
  }, [dispatch]);

  // const processedImages = useMemo(() => {
  //   return (
  //     allColleges?.flatMap((college) =>
  //       college?.college_banner_images
  //         ?.filter((img) => (isMobile ? img?.resue === "1:1" : img?.resue === "16:9"))
  //         ?.map((image) => ({
  //           src: axios.defaults.baseURL + image?.image_url,
  //           alt: "College Banner",
  //         }))
  //     ) || []
  //   );
  // }, [allColleges, isMobile]);
  const location = useLocation();

  useEffect(() => {
    const scrollTo = location.state?.scrollTo;
    const offset = 100; // adjust as needed

    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div id="home" className="bg-white w-full min-h-screen">
      {isLoading && <LogoLoader />}

      {/* Always show banner (whether or not it's done loading) */}
      <div className="w-full relative overflow-hidden">
        <Sliderimages
        // AllImages={processedImages}
        // isMobile={isMobile}
        // onImagesLoaded={(value) => { setBannerReady(value); }}
        // setBannerReady={setBannerReady}
        // noimages={noimages}
        // setNoimages={setNoimages}
        // setA={setA}
        // a={a}
        />
      </div>

      {/* Inquiry Popup */}
      {/* {showInquiryForm && <UserEnquiryModel onClose={handleClose} />} */}
      {/* Show rest of the page ONLY after banner is loaded */}
      {/* {((bannerReady && !noimages) || (!bannerReady && noimages)) && ( */}
      {/* <> */}
      <Aboutus />
      {/* <EventsPageForHome allEvents={allEvents} /> */}
      <OfferedCoursesSection />
      {/* <UserRecruiters /> */}
      {/* <HomePageTestimonial /> */}
      {/* <CollegeAtGlaneSection title="Lokmanya College at Glance" /> */}
      <Footer />
      {/* </> */}
      {/* )} */}
    </div>
  );
}

export default Home;
